<template>
    <div
        :style="{ 'background-color': '#cccccc', 'padding': '0px', 'margin': '0px', 'height': hh + 'px', 'overflow': 'auto', 'width': '100%' }">
        <div class="news" v-for="item in newslist" :key="item.NEWS.new_id">
            <div style="position:relative;right: -100px;float: right; z-index: 1000;" v-if="showmode == 'CHK'">
                <el-button type="warning" @click="summit(item.NEWS)">审核</el-button>
            </div>
            <h1 class="title">{{ item.NEWS.new_title }}<span class="new" v-if="item.NEWS.new_isdf == '否'">new</span>
            </h1>            
            <div class="subtitle">
                日期：{{ item.NEWS.new_date }} 单位：{{ UNIT.unit_name }}<br />
                {{ RULE.EVA_NAME }}<br />
                {{ item.NEWS.new_subtitle }}
                <hr />
            </div>
            <div class="content">
                <div class="divimg">
                    <div v-for="file in item.FILES" :key="file.file_id">
                        <iframe :src="file.file_url" style="width:100%;border:0px;height:500px;"
                            v-if="file.file_ext == '.pdf'"></iframe>
                        <div class="IMG" v-else>
                            <img :src="file.file_url" :alt="file.file_name">
                            <div>{{ file.file_name }}</div>
                        </div>
                    </div>
                </div>
                <div v-html="formathtml(item.NEWS.new_content)"></div>
                
            </div>
            <div class="check">
                <table style="width:100%;">
                    <tr v-for="chk in item.FLOWS" :key="chk.f_id">
                        <td style="height:200px;text-align:center;vertical-align:bottom;border:1px;"
                            v-if="chk.f_opinion != '系统自动通过'">
                            <div style="position: relative" v-html="formathtml(chk.f_opinion)">
                            </div>
                            <div>{{ chk.f_linker }}</div>
                            <div>{{ chk.f_date }}</div>
                        </td>
                    </tr>
                </table>
            </div>
        </div>
        <el-dialog title="材料审核" :visible="dialogFormVisible1" :show-close="false" width="60%" append-to-body  v-dialogDrag>
            <el-descriptions :column="3" border :labelStyle="{width:'120px'}">
                <el-descriptions-item :span="3">
                    <template slot="label">材料标题：</template>
                    {{itemedit.new_title}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">审批日期：</template>
                    {{sfc.f_date}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">审批人：</template>
                    {{sfc.f_linker}}
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">上报日期：</template>
                    {{itemedit.edit_date}}
                </el-descriptions-item>
                <el-descriptions-item :span="2">
                    <template slot="label">审核方式：</template>
                    <el-radio-group v-model="sfc.f_check">
                        <el-radio label="通过">通过</el-radio>
                        <el-radio label="不通过">不通过</el-radio>
                    </el-radio-group>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">截止时间：</template>
                    {{itemedit.edit_date}}
                </el-descriptions-item>
                <el-descriptions-item :span="3">
                    <template slot="label">审批意见：</template>
                <el-input size="mini" type="textarea" v-model="sfc.f_opinion" :row="8" :maxlength="SYS.len.chkmsglen"></el-input>
                <div style="color:#c0c0c0;font-size: 10px;float:right;">
                    {{sfc.f_opinion?sfc.f_opinion.length:0}}/{{SYS.len.chkmsglen}}
                </div>
                </el-descriptions-item>
            </el-descriptions>
            <div slot="footer" class="dialog-footer">        
                <el-button @click="dialogFormVisible1=false">取 消</el-button>
                <el-button type="primary" @click="summitdata()">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
// import Vue from 'vue'
// Vue.forceUpdate()
export default {
    data() {
        return {
            newslist: [],
            UNIT: {},
            RULE: {},
            dialogFormVisible1:false,
            sfc:{
                f_check:'通过',
                f_opinion:'',
            },
            
            itemedit: {},
        }
    },
    props: {
        pars:{
            type:Object,
            default: {
                eva_id: "",
                adv_id: ""
            }
        },
        showmode: {
            type: String,
            default:"CHK"//CHK审核打分，SHOW查看
        },
        hh: {
            type: Number,
            default() {
                return document.documentElement.clientHeight - 220;
            }
        }
    },
    mounted() {
        this.getlist();
    },
    methods: {
        getlist() {
            //this.newslist = []
            let that = this
            //let pars =  { eva_id: that.eva_id, adv_id: that.adv_id }            
            that.GetData('Flow/GetNewsList',that.pars, function (res) {
                console.log(res)
                that.UNIT = res.data.UNIT
                that.RULE = res.data.RULE
                that.newslist = res.data.data;
                //that.$forceUpdate()
            },function(err){
                console.log(err)
            })
        },
        summit(item){
            let that = this
            that.itemedit = item;
            that.GetData('Flow/GetCheckNews',{new_id:item.new_id},function(res){
                that.sfc = res.data.data;
                that.dialogFormVisible1 = true;
            },function(err){
                that.$alert(err, { title: "错误" });
            })
            
        },
        summitdata() {
            let that = this
            if(that.sfc.f_check!='通过' && that.sfc.f_check!='不通过' ){
                that.$alert("请选择审批方式！", {title: "错误",type:'error'});
                return;
            }
            if(that.sfc.f_check == '不通过' && !that.sfc.f_opinion){
                that.$alert('请输入审批意见！', { title: "错误" });
                return;
            }
            let pars={
                f_id:that.sfc.f_id,
                f_type:'材料上报申请',
                obj_id:that.itemedit.new_id,
                f_check:that.sfc.f_check,
                f_opinion:that.sfc.f_opinion
            }
            that.PostData('Flow/FLOWGO', pars, function (res) {
                that.getlist();
                that.dialogFormVisible1 = false;                
                that.$emit('refreshdataevent', null);
            }, function (err) {
                that.$alert(err, { title: "错误" });
            })
        }
    }
}
</script>

<style l lang="less" scoped>
.news {
    margin-top: 10px;
    margin-bottom: 20px;
    padding: 30px;
    width: 800px;
    margin-left: auto;
    margin-right: auto;
    background-color: White;
    line-height: 30px;
    border-radius: 5px;
}

.title {
    font-size: 20px;
    font-weight: bold;
    text-align: center;
}

.subtitle {
    font-size: 14px;
    text-align: center;

    hr {
        border: 1px dotted #808080;
    }
}

.content {
    font-size: 14px;
    line-height: 35px;
    text-align: left;

    .divimg {
        clear: both;
    }

    .IMG {
        /* margin: 10px; */
        border: 1px dotted #999999;
        /* padding: 10px; */
        float: left;
        text-align: center;
        font-size: 12px;
        display: flex;
        flex-direction: column;
        position: initial;
        left: 0;
        right: 0;
        width: 100%;

        img {
            position: relative;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            width: 100%;
        }
    }

    p {
        text-indent: 30px;
    }
}

.check {
    line-height: 23px;
}

.edittable {
    width: 100%;
    border-style: dotted;
    border-width: 0px 0px 0px 0px;
    border-color: #cccccc;

    td {
        border-left: 0px dotted #cccccc;
        border-right: 1px dotted #cccccc;
        border-top: 0px dotted #cccccc;
        border-bottom: 1px dotted #cccccc;
    }

    .tdheader {
        text-align: center;
        font-weight: normal;
        background-color: #F0F0F0;
        text-align: center;
        height: 28px;
        background-color: #fafafa;
        min-width: 100px;
    }
}

.new {
    font-size: 15px;
    color: red;
    padding: 3px;
}
</style>
